
import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';

function Progress() {
    return (
        <div className='progress'>
       <CircularProgress color='secondary' className="flex justify-center items-center m-auto"/>
       </div>
    )
}

export default Progress
